'use strict';

app.controller('ReportCtrl', [
    '$scope',
    '$http',
    '$translate',
    '$window',
    '$timeout',
    '$stateParams',
    '$ngConfirm',
    'toaster',
    'Microservice',
    function (
        $scope,
        $http,
        $translate,
        $window,
        $timeout,
        $stateParams,
        $ngConfirm,
        toaster,
        Microservice,
    ) {
        var REPORT_STEP_GETDATA = 1;
        var REPORT_STEP_GENERATE = 2;

        $scope.FORM_TAB = 1;
        $scope.LIST_TAB = 2;
        $scope.AUTOMAT_TAB = 3;

        $scope.REPORT_TYPE_MANUAL = 1;
        $scope.REPORT_TYPE_AUTOMATIC = 2;

        $scope.AUTOMATIC_RANGE_DAILY = 0;
        $scope.AUTOMATIC_RANGE_WEEKLY = 1;
        $scope.AUTOMATIC_RANGE_EVERY_TWO_WEEKS = 2;
        $scope.AUTOMATIC_RANGE_MONTHLY = 4;

        $scope.DATE_RANGE_TYPE_RANGE = 1;
        $scope.DATE_RANGE_TYPE_FROMTO = 2;

        $scope.DATE_RANGE_START = 1;
        $scope.DATE_RANGE_END = 2;

        $scope.DATE_RANGE_DAY = 1;
        $scope.DATE_RANGE_WEEK = 2;
        $scope.DATE_RANGE_MONTH = 3;

        $scope.STOP_SLIDER_FROM = 1;
        $scope.STOP_SLIDER_FROMTO = 2;

        $scope.STOP_SLIDER_DEFAULT_TIME = 3;

        $scope.OBJECT_TYPE_OBJECT = 1;
        $scope.OBJECT_TYPE_DRIVER = 2;
        $scope.OBJECT_TYPE_GROUP = 3;

        $scope.TIME_INTERVAL_DEFAULT = 30;
        $scope.MAX_COMBUSTION_DEFAULT = 40;

        $scope.FUEL_MINIMUM_DEFAULT = 0;

        $scope.loading = 0;

        $scope.tab = $scope.FORM_TAB;

        $scope.list = [];
        $scope.reports = [];
        $scope.automates = [];

        $scope.isManualReport = function (t) {
            return t === $scope.REPORT_TYPE_MANUAL;
        };
        $scope.isAutomaticReport = function (t) {
            return t === $scope.REPORT_TYPE_AUTOMATIC;
        };

        $scope.changeTab = function (v) {
            $scope.tab = v;

            $scope.resetForm();
            $timeout.cancel($scope.loadTimeout);

            if (v !== $scope.FORM_TAB) {
                $scope.list =
                    v === $scope.LIST_TAB ? $scope.reports : $scope.automates;
                $scope.load();
            }
        };
        $scope.isTab = function (tab) {
            return $scope.tab === tab;
        };

        $scope.loadTimeout = null;
        $scope.created = false;

        $scope.filters = [];
        $scope.options = {
            objects: angular.copy($scope.extractObjectsBySelectedGroup(false, false)),
            multiobjects: angular.copy($scope.extractObjectsBySelectedGroup(false, true)),
            groups: Object.values(angular.copy($scope.getObjectsGroups(['others']))),
            drivers: [],
            zones: [],
            zoneGroups: [],
            sliders: [
                {
                    id: $scope.STOP_SLIDER_FROM,
                    name: 'from',
                },
                {
                    id: $scope.STOP_SLIDER_FROMTO,
                    name: 'fromTo',
                },
            ],
            distanceSource: ['auto', 'can', 'gps'],
            fuelSource: ['auto', 'combustion', 'can', 'other'],
            fuelTankSource: ['auto', 'can', 'other'],
            reports: angular.copy($scope.app.user.reports.types),
            ranges: [
                {
                    id: $scope.DATE_RANGE_DAY,
                    name: 'day',
                    settings: {
                        startView: 'month',
                        minView: 'month',
                        maxView: 'month',
                    },
                },
                {
                    id: $scope.DATE_RANGE_WEEK,
                    name: 'week',
                    settings: {
                        startView: 'month',
                        minView: 'month',
                        maxView: 'month',
                    },
                },
                {
                    id: $scope.DATE_RANGE_MONTH,
                    name: 'month',
                    settings: {
                        startView: 'year',
                        minView: 'year',
                        maxView: 'year',
                    },
                },
            ],
            automate: {
                ranges: [
                    $scope.AUTOMATIC_RANGE_DAILY,
                    $scope.AUTOMATIC_RANGE_WEEKLY,
                    $scope.AUTOMATIC_RANGE_EVERY_TWO_WEEKS,
                    $scope.AUTOMATIC_RANGE_MONTHLY,
                ],
            },
        };

        var start = moment.utc().startOf('day');
        var end = moment.utc().endOf('day');

        $scope.form = {
            report: false,
            name: false,
            objects: [],
            drivers: [],
            groups: [],
            dates: {
                start: start,
                end: end,
            },
            distanceSource: '',
            fuelSource: 'auto',
            fuelTankSource: 'auto',
            zones: [],
            zoneGroups: [],
            range: {
                automate: $scope.options.automate.ranges[0],
                type: $scope.options.ranges[0],
                date: start,
            },
            slider: $scope.options.sliders[0],
            stop: $scope.STOP_SLIDER_DEFAULT_TIME,
            timeInterval: $scope.TIME_INTERVAL_DEFAULT,
            maxCombustion: $scope.MAX_COMBUSTION_DEFAULT,
            vat: {
                driver: {
                    on: false,
                    name: '',
                },
                shared: {
                    on: false,
                },
            },
            fuelMinimum: $scope.FUEL_MINIMUM_DEFAULT,
        };
        $scope.initialForm = angular.copy($scope.form);

        $scope.configurations = {
            rzSlider: {
                floor: 0,
                ceil: 60,
                step: 1,
                translate: function (value, sid, label) {
                    var hours = Math.floor(value / 60);
                    var mins = value % 60;

                    hours = ('0' + hours).slice(-2);
                    mins = ('0' + mins).slice(-2);

                    switch (label) {
                        case 'model':
                        case 'high': {
                            var text = hours + ':' + mins;
                            if (
                                $scope.form.slider.id ===
                                $scope.STOP_SLIDER_FROMTO
                            ) {
                                text = 'Stop < ' + text + ' < Pauza';
                            }
                            return text;
                        }
                        default: {
                            return '';
                        }
                    }
                },
            },
            rzFuelMinimum: {
                floor: 0,
                ceil: 100,
            }
        };

        $scope.verifyReportHasFilter = function (f) {
            return $scope.filters.indexOf(f) >= 0;
        };
        $scope.verifyReportByName = function (n) {
            return n === $scope.form.report.name;
        };

        $scope.isRoadCardReport = function () {
            return $scope.form.report.category === 'road-card';
        };

        $scope.isCalendarWorktimeReport = function () {
            return $scope.form.report.name === 'calendar-worktime';
        };

        $scope.isReportWithSpecifiedMultiselect = () => {
            return $scope.isRoadCardReport() || $scope.isCalendarWorktimeReport();
        }

        $scope.isAlreadyCreated = function (o) {
            return $scope.created === o.id;
        };

        $scope.toggleShowMore = function (report) {
            report.showMore = !report.showMore;
        };

        $scope.goToReportType = function () {
            var type = $stateParams.type;
            if (type === void 0) {
                return false;
            }

            var types = $scope.app.user.reports.types;
            angular.forEach(types, function (rt, key) {
                angular.forEach(rt, function (r, k) {
                    if (r.name === type) {
                        $scope.form.report = rt[k];
                        $scope.getReportFilters($scope.form.report);
                    }
                });
            });
        };

        $scope.onDateRangeChange = function (newValue, oldValue, t, w) {
            if (newValue === void 0) return;

            var start = angular.copy(newValue);
            var end = angular.copy(newValue);

            switch (t) {
                case $scope.DATE_RANGE_TYPE_RANGE: {
                    switch (w) {
                        case $scope.DATE_RANGE_DAY: {
                            $scope.form.dates.start = start.startOf('day');
                            $scope.form.dates.end = end.endOf('day');
                            break;
                        }
                        case $scope.DATE_RANGE_WEEK: {
                            $scope.form.dates.start = start
                                .startOf('week')
                                .isoWeekday(1);
                            $scope.form.dates.end = end
                                .endOf('week')
                                .isoWeekday(7);
                            break;
                        }
                        case $scope.DATE_RANGE_MONTH: {
                            $scope.form.dates.start = start.startOf('month');
                            $scope.form.dates.end = end.endOf('month');
                            break;
                        }
                    }
                    break;
                }
                case $scope.DATE_RANGE_TYPE_FROMTO: {
                    switch (w) {
                        case $scope.DATE_RANGE_START: {
                            if (
                                oldValue !== void 0 &&
                                !oldValue.isSame(newValue, 'day')
                            ) {
                                $scope.form.dates.start = start.startOf('day');
                            }
                            break;
                        }
                        case $scope.DATE_RANGE_END: {
                            if (
                                oldValue !== void 0 &&
                                !oldValue.isSame(newValue, 'day')
                            ) {
                                $scope.form.dates.end = end.endOf('day');
                            }
                            break;
                        }
                    }
                    break;
                }
            }
        };

        $scope.getReportFilters = function (report) {
            if (report !== void 0 && report !== null) {
                $scope.filters = report.filters;
                $scope.form.name = angular.copy(report.name);
            } else {
                $scope.filters = [];
            }

            $scope.form.slider = $scope.options.sliders[0];
            $scope.form.objects = [];

            if ($scope.form.name === 'zones-management') {
                $scope.getReportZones();
                $scope.getReportZonesGroups();
            }
        };

        $scope.modals = {
            goals: {
                instance: {},
                list: [],
                form: {
                    name: '',
                },
            },
            drivers: {
                instance: {},
                list: [],
                form: {
                    name: '',
                },
            },
            vat: {
                list: {},
            },
            mail: {
                receiver: '',
            }
        };

        $scope.getReportDrivers = function () {
            $http.get('/api/driver').then(function (response) {
                $scope.options.drivers = response.data.data;
            });
        };

        $scope.getReportZones = function () {
            $scope.loading++;
            Microservice.interceptor('zone', 'get', '/zones').then(function (response) {
                $scope.options.zones = response.data;
                $scope.loading--;
            }).catch(function (err) {
                console.error(err);
            });
        };


        $scope.getReportZonesGroups = function () {
            $scope.loading++;
            Microservice.interceptor('zone', 'get', '/zone-groups').then(function (response) {
                $scope.options.zoneGroups = response.data;
                $scope.loading--;
            }).catch(function (err) {
                console.error(err);
            });
        };

        $scope.validation = function (payload) {
            return payload.objectId.length && [1, 2].indexOf(payload.type) >= 0;
        };

        $scope.reportValidation = function (reportName, payload) {
            switch (reportName) {
                case 'vat-us':
                case 'vat-us-xls':
                    return true;
                default:
            }
            return true;
        };

        $scope.getRouteItems = function (type) {
            return $http.get('/api/routeItem/' + type).then(function (response) {
                $scope.modals[type].list = response.data.data;
            });
        };

        $scope.createRouteItem = function (type) {
            var name = $scope.modals[type].form.name;
            if (!name) return false;

            return $http
                .post('/api/routeItem/create', {type: type, name: name})
                .then(function () {
                    $scope.modals[type].form.name = '';
                    $scope.getRouteItems(type);
                });
        };

        $scope.deleteRouteItem = function (type, id) {
            $http
                .post('/api/routeItem/delete', {type: type, id: id})
                .then(function () {
                    $scope.getRouteItems(type);
                });
        };

        $scope.selectRouteItem = function (type, item) {
            Object.keys($scope.modals.vat.list).forEach(function (day) {
                for (var key in $scope.modals.vat.list[day]) {
                    $scope.modals.vat.list[day][key][
                    'Route' +
                    (
                        type.charAt(0).toUpperCase() + type.slice(1)
                    ).slice(0, -1)
                        ] = item;
                }
            });
            $scope.modals[type].instance.close();
        };

        $scope.manageRouteItems = function (type) {
            var title =
                type === 'goals' ? 'Cele podróży służbowych' : 'Kierowcy';
            $scope.modals.instance = type;

            $scope.modals[type].instance = $ngConfirm({
                title: title,
                contentUrl: 'tpl/pages/reports/modals/items.html',
                theme: 'supervan',
                columnClass: 'xl',
                icon: 'pe-7s-map-marker',
                scope: $scope,
                buttons: {
                    no: {
                        text: $translate.instant('general.confirm.save.cancel'),
                        btnClass: 'btn-info',
                        action: function () {
                            return true;
                        },
                    },
                },
            });
        };

        $scope.showVatUsModal = function (id, response) {
            $scope.modals.vat.list = response.data;
            $scope.modals.vat.modes = response.modes;

            $scope.getRouteItems('goals');
            $scope.getRouteItems('drivers');
            $ngConfirm({
                title: 'Modyfikacja raportu',
                contentUrl: 'tpl/pages/reports/modals/vat-us.html',
                theme: 'supervan',
                columnClass: 'xl',
                icon: 'pe-7s-map-marker',
                scope: $scope,
                buttons: {
                    yes: {
                        text: $translate.instant('general.confirm.save.ok'),
                        btnClass: 'btn-info',
                        action: function (scope) {
                            var payload = response;
                            payload.data = $scope.modals.vat.list;

                            $http
                                .post('/api/report/generate/' + id, payload)
                                .then(
                                    function (response) {
                                        $scope.created = id;
                                        $scope.changeTab($scope.LIST_TAB);

                                        toaster.pop(
                                            'info',
                                            $translate.instant(
                                                'reports.toastr.success.generated'
                                            )
                                        );
                                    },
                                    function () {
                                        toaster.pop(
                                            'error',
                                            $translate.instant('reports.toastr.error.header'),
                                            $translate.instant('reports.toastr.error.generated')
                                        );
                                    });
                            return true;
                        },
                    },
                    no: {
                        text: $translate.instant('general.confirm.save.cancel'),
                        btnClass: 'btn-dark',
                        action: function (scope) {
                            $scope.deleteReport(id, 'canceled');
                            return true;
                        },
                    },
                },
            });
        };

        $scope.openEmailModal = function(link, objects) {
            $ngConfirm({
                title: $translate.instant('reports.modals.mail.title'),
                contentUrl: 'tpl/pages/reports/modals/mail.html',
                theme: 'supervan',
                columnClass: 'xl',
                icon: 'pe-7s-mail',
                scope: $scope,
                buttons: {
                    yes: {
                        text: $translate.instant('general.confirm.ok'),
                        btnClass: 'btn-info',
                        action: function(scope) {
                            if (scope.sendReportFrom.$invalid) {
                                toaster.pop({
                                    type: 'error',
                                    title: $translate.instant(
                                        'general.toastr.error.header'
                                    ),
                                    body: $translate.instant(
                                        'error.InvalidForm'
                                    ),
                                });

                                return false;
                            }

                            var payload = {
                                objects: objects.join(', '),
                                client: $scope.app.user.code,
                                link: link,
                                mail: scope.modals.mail.receiver,
                                notes: scope.modals.mail.notes,
                                type: 'report',
                            };

                            var filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                            if (!filter.test(payload.mail)) {
                                return false;
                            }

                            scope.modals.mail.receiver = '';
                            scope.modals.mail.notes = '';

                            $http
                                .post('/api/notification/mail', payload)
                                .then(
                                    function (response) {
                                        toaster.pop(
                                            'success',
                                            $translate.instant('reports.toastr.success.header'),
                                            $translate.instant('reports.toastr.success.mail')
                                        );
                                    },
                                    function () {
                                        toaster.pop(
                                            'error',
                                            $translate.instant('reports.toastr.error.header'),
                                            $translate.instant('reports.toastr.error.mail')
                                        );
                                    });
                            return true;
                        },
                    },
                    no: {
                        text: $translate.instant('general.confirm.save.cancel'),
                        btnClass: 'btn-dark',
                        action: function() {},
                    },
                },
            });
        };

        $scope.chooseStep = function (reportName, payload) {
            if (payload.type === $scope.REPORT_TYPE_AUTOMATIC) {
                return REPORT_STEP_GETDATA;
            }

            switch (reportName) {
                case 'vat-us':
                case 'vat-us-xls':
                    return REPORT_STEP_GENERATE;
            }

            return REPORT_STEP_GETDATA;
        };

        $scope.afterSuccessCreate = function (id, type) {
            $scope.created = id;
            $scope.changeTab(
                type === $scope.REPORT_TYPE_AUTOMATIC
                    ? $scope.AUTOMAT_TAB
                    : $scope.LIST_TAB
            );

            toaster.pop(
                'info',
                $translate.instant(
                    'reports.toastr.success.generated'
                )
            );
        }

        $scope.steps = function (reportName, data) {
            switch (reportName) {
                case 'vat-us':
                case 'vat-us-xls':
                    $scope.showVatUsModal(data.id, data.report);
                    break;
            }
        };

        $scope.buildReport = function (type, reportFrom) {
            if ($window.ga) {
                $window.ga('send', 'event', 'generateReport', $scope.form.name);
            }

            var payload = $scope.buildPayload(type);

            if (!$scope.validation(payload) || reportFrom.$invalid) {
                toaster.pop(
                    'error',
                    $translate.instant('reports.toastr.error.header'),
                    $translate.instant(
                        'general.toastr.error.form.validation.fill'
                    )
                );
                return false;
            }

            var reportName = $scope.form.name;

            if (!$scope.reportValidation(reportName, payload)) {
                return false;
            }

            var url =
                '/api/report/create/' +
                $scope.form.name +
                '?lang=' +
                $scope.selectedLanguage;

            var step = $scope.chooseStep(reportName, payload);

            $http.post(url, {step: step, payload: payload}).then(
                function (response) {
                    var data = response.data.data;

                    if (data.step === REPORT_STEP_GETDATA) {
                        $scope.afterSuccessCreate(data.id, payload.type);
                    } else {
                        $scope.steps(reportName, data);
                    }
                },
                function () {
                    toaster.pop(
                        'error',
                        $translate.instant('reports.toastr.error.header'),
                        $translate.instant('reports.toastr.error.generated')
                    );
                }
            );
        };

        $scope.updateReportStatuses = function () {
            $http.get('/api/report/statuses').then(function (response) {
                var statuses = response.data.data;
                angular.forEach(statuses, function (value, key) {
                    angular.forEach($scope.list, function (r, k) {
                        if (r.id == value.id) {
                            if (
                                $scope.list[k].status !== value.status &&
                                value.status === -1
                            ) {
                                toaster.pop(
                                    'error',
                                    $translate.instant(
                                        'reports.toastr.error.header'
                                    ),
                                    $translate.instant(
                                        'reports.toastr.error.overloaded'
                                    )
                                );
                            }
                            $scope.list[k].status = angular.copy(value.status);
                            $scope.list[k].path = angular.copy(value.path);
                            $scope.list[k].dateUpdate = angular.copy(value.dateUpdate);
                        }
                    });
                });
            });
            $scope.loadTimeout = $timeout($scope.updateReportStatuses, 60000);
        };

        $scope.load = function () {
            $timeout.cancel($scope.loadTimeout);
            $http.get('/api/report/list').then(function (response) {
                var reports = response.data.data;
                $scope.reports = [];
                $scope.automates = [];

                angular.forEach(reports, function (v, k) {
                    v.showMore = true;
                    if (v.type === $scope.REPORT_TYPE_AUTOMATIC) {
                        $scope.automates.push(v);
                    } else {
                        $scope.reports.push(v);
                    }
                });
                $scope.list =
                    $scope.tab === $scope.LIST_TAB
                        ? $scope.reports
                        : $scope.automates;
                $scope.loadTimeout = $timeout(
                    $scope.updateReportStatuses,
                    60000
                );
            });
            return true;
        };

        $scope.deleteReport = function (id, type) {
            $http.delete('/api/report/' + id).then(
                function () {
                    $scope.load();
                    toaster.pop(
                        'success',
                        $translate.instant('reports.toastr.success.header'),
                        $translate.instant('reports.toastr.success.' + type)
                    );
                },
                function () {
                    toaster.pop(
                        'error',
                        $translate.instant('reports.toastr.error.header'),
                        $translate.instant('reports.toastr.error.' + type)
                    );
                }
            );
        };

        $scope.resetStopSlider = function () {
            $scope.form.stop = $scope.STOP_SLIDER_DEFAULT_TIME;
        };

        $scope.resetReport = function (report) {
            report.status = 0;
            $http.put('/api/report/' + report.id, {status: 0});
        };

        $scope.getReportDownloadAttribute = function (report) {
            switch (report.report) {
                case 'karta-drogowa-restore-xls':
                case 'karta-drogowa-xls':
                case 'karta-drogowa-worktime-xls':
                case 'karta-drogowa-simple-xls':
                case 'milog-xls':
                case 'milog-xls-drivers': {
                    return report.report + '.xls';
                }
                case 'milog-xml': {
                    return report.report + '.xml';
                }
            }
            return false;
        };

        $scope.resetForm = function () {
            $scope.form = angular.copy($scope.initialForm);
        };

        $scope.$on('$destroy', function () {
            $timeout.cancel($scope.loadTimeout);
        });

        $scope.buildPayload = function (type) {
            var form = $scope.form;
            var payload = {
                type: type,
                range: form.range.automate,
                dateFrom:
                    form.dates.start instanceof moment
                        ? form.dates.start.format('YYYY-MM-DD HH:mm:ss')
                        : form.dates.start,
                dateTo:
                    form.dates.end instanceof moment
                        ? form.dates.end.format('YYYY-MM-DD HH:mm:ss')
                        : form.dates.end,
            };

            if ($scope.verifyReportHasFilter('slider')) {
                payload.stopTime = form.stop;

                if (form.slider.id === $scope.STOP_SLIDER_FROMTO) {
                    payload.stopAndPause = 1;
                }
            }

            if ($scope.verifyReportHasFilter('timeInterval')) {
                payload.timeInterval = form.timeInterval;
            }

            if ($scope.verifyReportHasFilter('distanceSource')) {
                payload.distanceSource = form.distanceSource;
            }

            if ($scope.verifyReportHasFilter('fuelSource')) {
                payload.fuelSource = form.fuelSource;
            }

            if ($scope.verifyReportHasFilter('fuelTankSource')) {
                payload.fuelTankSource = form.fuelTankSource;
            }

            if ($scope.verifyReportHasFilter('fuelMinimum')) {
                payload.fuelMinimum = form.fuelMinimum;
            }

            if ($scope.verifyReportHasFilter('maxCombustion')) {
                payload.maxCombustion = form.maxCombustion;
            }

            if ($scope.verifyReportHasFilter('zones')) {
                payload.zones = form.zones.map(function (z) {
                    return z.id;
                });
            }

            if ($scope.verifyReportHasFilter('zoneGroups')) {
                payload.zoneGroups = form.zoneGroups.map(function (z) {
                    return z.id;
                });
            }

            if ($scope.verifyReportByName('vat-us') || $scope.verifyReportByName('vat-us-xls')) {
                payload.vat = form.vat;
            }

            if (!$scope.isReportWithSpecifiedMultiselect()) {
                payload.objectId = $scope.verifyReportHasFilter('objectId')
                    ? form.objects.map(function (o) {
                        return o.objectId;
                    })
                    : $scope.verifyReportHasFilter('driverId')
                        ? form.drivers.map(function (o) {
                            return o.driverId;
                        })
                        : [];
            } else {
                payload.objectType = $scope.OBJECT_TYPE_OBJECT;

                if (form.objects.length > 0) {
                    payload.objectId = form.objects.map(function (o) {
                        return o.objectId;
                    });
                } else if (form.drivers.length > 0) {
                    payload.objectId = form.drivers.map(function (o) {
                        return o.driverId;
                    });

                    payload.objectType = $scope.OBJECT_TYPE_DRIVER;
                } else if (form.groups.length > 0) {
                    payload.objectId = form.groups.map(function (o) {
                        return o.groupId;
                    });

                    payload.objectType = $scope.OBJECT_TYPE_GROUP;
                } else {
                    payload.objectId = [];
                }
            }

            return payload;
        };

        $scope.isObjectTypeDriver = function () {
            return true;
        };

        $scope.init = function () {
            $scope.goToReportType();
            $scope.getReportDrivers();
            $scope.load();
        };
        $scope.init();
    },
]);
